import React, { Component } from 'react';

class middlesection extends Component {

  render() {
    const { smallTitle, title, section } = this.props
    const classname = (section !== undefined)?`middle-section section-${section} cover`: 'middle-section cover'

    return (
      <div className={classname}>
        <div className="section-frame"/>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="middle-contents">
                <h1 className="small-title light">{smallTitle}</h1>
                <h2 className="h1 heavy">{title}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default middlesection;



// WEBPACK FOOTER //
// ./src/shared/routes/components/middleSection.js